export default "__VITE_ASSET__BV6Wi00L__"